const rules = {
  admin: [
    'basicMessages:create',
    'basicMessages:read',
    'contacts:create',
    'contacts:read',
    'contacts:update',
    'contacts:delete',
    'contextFiles:set',
    'contextFiles:read',
    'contextFiles:delete',
    'credentials:issue',
    'credentials:read',
    'credentials:reissue',
    'credentials:revoke',
    'credentialsReceived:delete',
    'credentialsReceived:read',
    'credentialsShared:read',
    'did:create',
    'did:setPublic',
    'emails:verify',
    'governanceEditorFiles:read',
    'governanceEditorFiles:save',
    'governanceEditorFiles:set',
    'governanceEditorFiles:delete',
    'governanceFiles:read',
    'governanceFiles:set',
    'governanceFiles:delete',
    'invitations:create',
    'invitations:accept',
    'invitations:delete',
    'invitations:read',
    'invitations:update',
    'ledger:readTaa',
    'ledger:acceptTaa',
    'multitenancy:read',
    'multitenancy:createAPIKey',
    'multitenancy:revokeAPIKey',
    'multitenancy:createWalletSettings',
    'multitenancy:setSelectedWallet',
    'presentations:read',
    'presentations:request',
    'roles:read',
    'schemas:create',
    'schemas:read',
    'schemas:update',
    'schemas:set',
    'schemas:delete',
    'settings:read',
    'settings:update',
    'statusList:create',
    'statusList:read',
    'statusList:update',
    'statusList:delete',
    'verifications:verifyFlow',
    'verifications:read',
  ],
  technician: [
    'basicMessages:create',
    'basicMessages:read',
    'contacts:create',
    'contacts:read',
    'contacts:update',
    'contextFiles:set',
    'contextFiles:read',
    'contextFiles:delete',
    'credentials:issue',
    'credentials:read',
    'credentials:reissue',
    'credentials:revoke',
    'credentialsReceived:read',
    'credentialsShared:read',
    'invitations:create',
    'invitations:read',
    'invitations:update',
    'invitations:accept',
    'ledger:readTaa',
    'multitenancy:setSelectedWallet',
    'presentations:read',
    'presentations:request',
    'schemas:read',
  ],
  'super-admin': [
    'multitenancy:createWallet',
    'multitenancy:read',
    'multitenancy:createAPIKey',
    'multitenancy:revokeAPIKey',
    'multitenancy:createWalletSettings',
    'roles:read',
    'settings:update',
  ],
}

export default rules
